import React from 'react';
import { Outlet } from 'react-router-dom';

export const Locations: React.FC = () => {
  return <Outlet />;
};
